import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAdminAuth } from '../../hooks/useAdminAuth';

const AdminPageApproved = () => {

   const { logoutAdmin } = useAdminAuth();
   const [users, setUsers] = useState([])
   const urlBase = 'https://pt-api.digit-a.net/api'
   const [currentPage, setCurrentPage] = useState(1);
   const [refreshUsers, setRefreshUsers] = useState(false);
   const [loading, setLoading] = useState(true);
   const usersPerPage = 10;

   useEffect(() => {
      const gerApprovedUsers = async () => {
         setLoading(true);
         try {
            const response = await fetch(`${urlBase}/users/get-list-users`);
            if (!response.ok) {
               throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            const pendingUsers = data
               .filter(user => user.kycValidated === true)
               // Ordena del más reciente al más antiguo
               .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

            setUsers(pendingUsers);
         } catch (error) {
            console.error('Error fetching or processing data:', error);
         } finally {
            setLoading(false);
         }
      };
      gerApprovedUsers();
   }, [refreshUsers])

   const handleDelete = async (email) => {
      // Muestra una alerta de confirmación
      if (window.confirm(`¿Estás seguro de que quieres eliminar al usuario ${email}?`)) {
         try {
            const response = await fetch(`${urlBase}/users/delete-user-by-email`, {
               method: 'DELETE',
               headers: {
                  'Content-Type': 'application/json',
               },
               body: JSON.stringify({ email }),
            });

            if (!response.ok) {
               throw new Error(`Error al eliminar: ${response.statusText}`);
            }

            alert('Usuario eliminado exitosamente.');
            // Dispara el useEffect para refrescar la lista de usuarios
            setRefreshUsers(prev => !prev);

         } catch (error) {
            console.error('Error al eliminar el usuario:', error);
            alert('Hubo un error al intentar eliminar al usuario.');
         }
      }
   };


   const paginate = (pageNumber) => setCurrentPage(pageNumber);
   // Lógica de Paginación const indexOfLastUser = currentPage * usersPerPage;
   const indexOfLastUser = currentPage * usersPerPage;
   const indexOfFirstUser = indexOfLastUser - usersPerPage;
   const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

   return (
      <div className="ppt_admin_content">
         <nav className="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            <div className="container-fluid max py-4">
               <div className="row align-items-center justify-content-between w-100">
                  <div className="col-auto">
                     <NavLink to="/dashboard" className="">
                        <img src={process.env.PUBLIC_URL + '/assets/img/lm_logo_propert.svg'} alt="ProperT" border="0" />
                     </NavLink>
                  </div>
                  <div className="col-auto col-lg-6">
                     <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <div className="col">
                           <nav className="ppt_navdash">
                              <NavLink to="/admin/pending-kyc-users" className="text-black link">USERS</NavLink>
                              <NavLink to="/admin/pending-transactions" className="text-black link">TRANSACTIONS</NavLink>
                           </nav>
                        </div>
                     </div>
                  </div>
                  <div className="col-auto">
                     <span onClick={logoutAdmin} style={{ cursor: 'pointer' }}>
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_logout_alt.svg'} alt="Logout" border="0" />
                     </span>
                  </div>
               </div>
            </div>
         </nav>
         <div className="container-fluid max">
            <div className="row">
               <div className="col-12 mb-5">
                  <div className="ppt_header d-flex justify-content-between align-items-center">
                     <nav className="ppt_navdash_scd">
                        <NavLink to="/admin/pending-kyc-users" className="text-black link">Users pending for KYC approval</NavLink>
                        <NavLink to="/admin/approved-kyc-users" className="text-black link">Approved</NavLink>
                     </nav>
                  </div>
               </div>
               <div className='col-12'>
                  <h4 className="mb-4">Users approved</h4>
                  <div className="ppt_admin_genlist">

                     {loading ? (
                        <p>Loading...</p>
                     ) : (currentUsers.map(({ _id, email, createdAt }) => {
                        const dateObj = new Date(createdAt);
                        const date = `${String(dateObj.getDate()).padStart(2, '0')}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${dateObj.getFullYear()}`;
                        const time = `${String(dateObj.getHours()).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}`;

                        return (
                           <div className="ppt_admin_genlist_item py-4" key={_id}>
                              <span className="user">
                                 <img src={process.env.PUBLIC_URL + '/assets/img/icon_user_alt.svg'} alt="User" border="0" />
                                 <p>{email}</p>
                              </span>
                              <span className="status_icon">
                                 <img src={process.env.PUBLIC_URL + '/assets/img/icon_check_alt.svg'} alt="Approved" border="0" width={'24px'} />
                              </span>
                              <span className="date">
                                 {date}
                              </span>
                              <span className="hour">
                                 {time}
                              </span>
                              <span className="actions">
                                 {/* Agrega el evento onClick aquí */}
                                 <span className="btn_delete" onClick={() => handleDelete(email)}>
                                    <img src={process.env.PUBLIC_URL + '/assets/img/icon_bin.svg'} alt="Delete" border="0" width={'16px'} />
                                 </span>
                              </span>
                           </div>
                        );
                     })
                     )}
                  </div>
                  <div className="pagination d-flex justify-content-center m-5">
                     {Array.from({ length: Math.ceil(users.length / usersPerPage) }, (_, i) => (
                        <button key={i + 1} onClick={() => paginate(i + 1)} className={`btn ${currentPage === i + 1 ? 'btn-warning' : 'btn-outline-secondary'} mx-1`}>
                           {i + 1}
                        </button>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};
export default AdminPageApproved;